var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    { attrs: { value: _vm.open, persistent: "", "max-width": "350" } },
    [
      _c(
        "v-card",
        { staticClass: "home-form-container", attrs: { color: "#f0f0ef" } },
        [
          _vm.editedItem !== null
            ? _c(
                "v-card-text",
                {
                  staticClass: "home-form-container",
                  staticStyle: { "text-align": "left", padding: "4px 0 0 0" }
                },
                [
                  _c(
                    "v-layout",
                    {
                      staticStyle: { "margin-bottom": "10px" },
                      attrs: { row: "" }
                    },
                    [
                      _c("input-field", {
                        attrs: {
                          label: _vm.$tc("Label", 1),
                          inputType: "text",
                          size: "large"
                        },
                        model: {
                          value: _vm.editedItem.sp_label,
                          callback: function($$v) {
                            _vm.$set(_vm.editedItem, "sp_label", $$v)
                          },
                          expression: "editedItem.sp_label"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-card-actions",
            [
              _c("v-spacer"),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  attrs: { text: "", "x-small": "" },
                  on: { click: _vm.close }
                },
                [_vm._v("\n        " + _vm._s(_vm.$t("Cancel")) + "\n      ")]
              ),
              _vm._v(" "),
              _c(
                "v-btn",
                {
                  staticStyle: { "margin-right": "10px" },
                  attrs: { "x-small": "", color: "accent" },
                  on: { click: _vm.applyChanges }
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("ApplyChanges")) + "\n      "
                  )
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-336850f1", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-336850f1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Forms/_SpecialTabs/Splitters/SplitterEditionForm.vue
// module id = null
// module chunks = 